import { ReactElement } from 'react';

import { useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { getRecipientCategories, RecipientCategory } from '~libs.shared.prescription';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';
import { DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';

const ITEMS = Array.from(getRecipientCategories());

const useTriggerLabelExtractor = (): ((prescriptionCategory: RecipientCategory) => string) => {
   const translate = useTranslate();
   return (prescriptionType) => {
      return translate(draftPrescriptionsTranslationKeys.prescriptionType.select[prescriptionType]);
   };
};

type PrescriptionCategoryFieldProps = Pick<DraftPrescriptionsFormController, 'register'>;

export const PrescriptionCategoryField = (props: PrescriptionCategoryFieldProps): ReactElement => {
   return (
      <Select<RecipientCategory>
         testId={'prescriptionCategory'}
         triggerLabelExtractor={useTriggerLabelExtractor()}
         controller={props.register('prescriptionCategory')}
         compact
      >
         <Select.List items={ITEMS}>
            {(item) => (
               <Select.Item
                  testId={item}
                  item={item}
                  label={draftPrescriptionsTranslationKeys.prescriptionType.select[item]}
               />
            )}
         </Select.List>
      </Select>
   );
};
